import * as React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok";
import * as styles from "./richtext.module.css"

const BodyText = ({ blok }) => {
  // console.log(blok);
  return (
    <div {...storyblokEditable(blok)} 
      id={blok._uid}
      className={`leading-relaxed text-left ${styles.richText}`} 
      style={{
        marginTop: `${blok.marginTop}px`,
        marginBottom: `${blok.marginBottom}px`,
        paddingTop: `${blok.paddingTop}px`,
        paddingBottom: `${blok.paddingBottom}px`,
        paddingLeft: `1rem`,
        paddingRight: `1rem`,
        borderWidth: `${blok.borderWidth}px`,
        borderColor: `${blok.borderColor?.color}`,
        backgroundColor: `${blok.bgColor?.color}`,
      }}>
      <div dangerouslySetInnerHTML={{__html: renderRichText(blok.paragraphs)}} />
      {blok.headingAlign && <style>{`
        [id='${blok._uid}'] {
          h1, h2, h3 {
            text-align: ${blok.headingAlign};
          }
        }
      `}</style>}
    </div>
  )
}

export default BodyText
